module.exports = __webpack_public_path__ + "static/media/arrow_grey.2a632f84.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow_grey.svg
// module id = 114
// module chunks = 0